interface IFreateIframeArgs {
    url: string;
    id: string;
    container?: HTMLElement;
    iframe: HTMLIFrameElement;
    extraData?: Record<string, string>;
}

export const createIframe = ({ url, id, container, iframe, extraData }: IFreateIframeArgs) => {
    if (url) {
        iframe.src = url;
    }
    iframe.name = id;
    iframe.id = id;
    iframe.allowFullscreen = true;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameBorder = '0';

    if (extraData) {
        Object.entries(extraData).forEach(([key, value]) => {
            iframe.setAttribute(`data-${key}`, value);
        });
    }
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('onmousewheel', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.style.opacity = url ? '0' : '1';

    container?.appendChild(iframe);

    return iframe;
};
